var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 73.75C61.9975 73.75 73.75 61.9975 73.75 47.5C73.75 33.0025 61.9975 21.25 47.5 21.25C33.0025 21.25 21.25 33.0025 21.25 47.5C21.25 61.9975 33.0025 73.75 47.5 73.75Z",
    stroke: "url(#paint0_linear_180_7744)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9125 71.25H6.25V27.5M6.25 27.5H25.4125M6.25 27.5H23.75M6.25 27.5V11.25H11.1M62.35 11.25H66.25V23.125M24.0625 11.25H49.0625M47.5 33.75V47.5L56.25 52.5M47.5 67.5V73.75M57.5 64.825L60.625 70.2375M64.825 57.5L70.2375 60.625M67.5 47.5H73.75M64.825 37.5L70.2375 34.375M57.5 30.175L60.625 24.7625M47.5 27.5V21.25M37.5 30.175L34.375 24.7625M30.175 37.5L24.7625 34.375M27.5 47.5H21.25M30.175 57.5L24.7625 60.625M37.5 64.825L34.375 70.2375",
    stroke: "url(#paint1_linear_180_7744)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.225 41.25H12.5V32.5H21.25M18.225 53.75H12.5V45H17.6M21.25 62.4V66.25H12.5V57.5H18.225M53.75 6.25H58.75V16.25H53.75V6.25ZM15 6.25H20V16.25H15V6.25Z",
    stroke: "url(#paint2_linear_180_7744)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_7744",
    x1: 21.2503,
    y1: 47.5004,
    x2: 73.75,
    y2: 47.5004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_7744",
    x1: 6.25034,
    y1: 42.5005,
    x2: 73.75,
    y2: 42.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_7744",
    x1: 12.5002,
    y1: 36.2505,
    x2: 58.75,
    y2: 36.2505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.a6766ddcd554f62c2de02bf43d013104.svg";
export { ForwardRef as ReactComponent };